import { createContext, useContext, useEffect, useState } from "react";
import {
  ICarrier,
  IConfigurationContext,
  IConfigurationRules,
  IGetRulesByEntity,
} from "../interfaces/configuration";
import { getCarriers } from "../requests/carrierRequests";
import { UserContext } from "./userContext";
import { MARKETPLACE, MERCHANT, ECOMMERCE } from "../utils/constants";

export const ConfigurationContext = createContext({} as IConfigurationContext);

const getRulesByEntity = ({
  entity,
  contractOwner,
  merchantCanDisableCarriers,
}: IGetRulesByEntity) => {
  const rulesByEntity: { [key: string]: IConfigurationRules } = {
    [MARKETPLACE]: {
      canFulfillCredentials: contractOwner === MARKETPLACE,
      canActiveCarriers: contractOwner === MERCHANT,
      canDisableOL: contractOwner === MARKETPLACE,
    },
    [MERCHANT]: {
      canFulfillCredentials: contractOwner === MERCHANT,
      canDisableOL: merchantCanDisableCarriers,
    },
    [ECOMMERCE]: {
      canFulfillCredentials: true,
      canDisableOL: true,
    },
  };

  return contractOwner || entity === ECOMMERCE ? rulesByEntity[entity] : {};
};

const ConfigurationProvider = ({ children }: any) => {
  const {
    currentUser: { entity },
    rules,
    selectedMarketplace,
  } = useContext(UserContext);
  const [availableCarriers, setAvailableCarriers] = useState<ICarrier[]>([]);
  const [configurationRules, setConfigurationRules] = useState(
    {} as IConfigurationRules
  );
  const [loading, setLoading] = useState<boolean>(true);

  const fetchAvailableCarriers = async () => {
    setLoading(true);
    try {
      const fetchedCarriers = await getCarriers({
        entity,
        selectedMarketplace,
        fetchCredentials: true,
      });
      setAvailableCarriers(fetchedCarriers);
    } catch (error: any) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAvailableCarriers();
  }, [selectedMarketplace]);

  useEffect(() => {
    setConfigurationRules(
      getRulesByEntity({
        entity,
        contractOwner: rules.contractOwner,
        merchantCanDisableCarriers: rules.merchantCanDisableCarriers as boolean,
      })
    );
  }, [rules]);

  return (
    <ConfigurationContext.Provider
      value={{ availableCarriers, configurationRules, loading }}
    >
      {children}
    </ConfigurationContext.Provider>
  );
};

export default ConfigurationProvider;
